import React, { useEffect, useState } from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { debounce } from 'lodash';
import { Autocomplete } from '@material-ui/lab';

import { useGetCities } from '../hooks/useGetCities';

const LIMIT_INTERVAL = 2000;

export const CdekCities = ({
  chosenCdekCity,
  fullChosenCdekCity,
  setChosenCdekCity,
  readOnly
}: {
  chosenCdekCity: string;
  fullChosenCdekCity: string;
  setChosenCdekCity: (city: string, fullName: string) => void;
  readOnly?: boolean;
}) => {
  const intl = useIntl();
  const { fetchCities, loadingCdekCities, cdekCities } = useGetCities();

  const [location, setLocation] = useState<string>('');
  const [fetchedLocation, setFetchedLocation] = useState('');

  const [cdekCitiesToShow, setCdekCitiesToShow] = useState<any>([]);

  useEffect(() => {
    setCdekCitiesToShow(
      cdekCities
        ?.filter((i: any) => i.country_code === 'RU')
        .map((x: any) => ({ ...x, label: x.city, key: x.uuid })) || []
    );
  }, [cdekCities]);

  const handleInputChange = (_e: any, _val: string, reason: any) => {
    if (reason === 'clear') {
      setChosenCdekCity('', '');
    } else if (reason === 'input') {
      setLocation(_val);
    }
  };

  const fetchDebouncedLocations = debounce(() => {
    if (location.length >= 3 && location !== fetchedLocation) {
      fetchCities(location);
      setFetchedLocation(location);
    }
  }, LIMIT_INTERVAL);

  useEffect(() => {
    fetchDebouncedLocations();
    return () => fetchDebouncedLocations.cancel();
  }, [location]);

  return (
    <>
      <Autocomplete
        options={cdekCitiesToShow}
        autoHighlight
        value={fullChosenCdekCity || chosenCdekCity}
        onChange={(_, value: any) => {
          setChosenCdekCity(value?.city || value || '', value?.full_name || '');
        }}
        onInputChange={handleInputChange}
        noOptionsText='Пусто'
        disabled={readOnly}
        filterOptions={o => o}
        renderOption={(props: any, option: any) => {
          return (
            <li {...option} key={props}>
              {props?.full_name || props?.city || props}
            </li>
          );
        }}
        renderInput={params => {
          return (
            <TextField
              {...params}
              type='text'
              margin='normal'
              name='location'
              variant='outlined'
              disabled={readOnly}
              error={!readOnly && !chosenCdekCity}
              helperText={!readOnly && !chosenCdekCity && 'Выберите населенный пункт'}
              label={intl.formatMessage({
                id: 'STORE.INPUT.CDEKLOCATION',
              })}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {(loadingCdekCities ||
                      (location && location.length >= 3 && location !== fetchedLocation)) && (
                      <CircularProgress color='inherit' size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          );
        }}
      />
    </>
  );
};
